import styled from "styled-components"
import { Atom } from 'AppReact';

const template = styled.label`
  cursor: pointer;
  margin: 0px;
`;

export default Atom({ type: 'uploadMultiple', dataType: 'image/*, video/*', template })